import { render, staticRenderFns } from "./Rateio.vue?vue&type=template&id=1b8af556"
import script from "./Rateio.vue?vue&type=script&lang=js"
export * from "./Rateio.vue?vue&type=script&lang=js"
import style0 from "./Rateio.vue?vue&type=style&index=0&id=1b8af556&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports